import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as ecModels from '../../../../models'
import type { Plugin } from '../plugin'

/**
 * Retrieves the entity for the desired {@link ecModels.Target}
 */
export const executeGetEntity = store.effects.create(
  <TTypeParams extends ecModels.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) =>
    feature.actions.getEntity.relay((forwardTo, { target }) =>
      plugin.storage.selectors.getFromIdLookup(target).asObservable.pipe(
        // We just want the current value of the current ID and then we move on
        // so the relay can complete
        rxjs.take(1),
        rxjs.map(id =>
          id
            ? forwardTo(
                plugin.collection.plugins.dataOperationPlugin.feature.actions
                  .get,
                {
                  input: { id },
                  output: ({ response }) => response,
                },
              )
            : {
                cancellation: {
                  reason: `No current entity ID for target: '${target}'`,
                },
              },
        ),
      ),
    ).asObservable,
)
